import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prevTime => {
        let {
          hours,
          minutes,
          seconds
        } = prevTime;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          hours = 23;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={scrollToPurchase} className="sticky top-0 z-50 bg-gradient-to-r from-red-600 to-red-700 text-white py-3 px-4 cursor-pointer hover:from-red-700 hover:to-red-800 transition-all" data-id="element-365">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-semibold" data-id="element-366">
        <span className="hidden sm:inline" data-id="element-367">
          🔥 OFERTA POR TIEMPO LIMITADO — TERMINA EN:
        </span>
        <span className="sm:hidden" data-id="element-368">⏰ OFERTA TERMINA EN:</span>
        <div className="flex gap-2 font-mono text-lg md:text-xl" data-id="element-369">
          <span className="bg-black/30 px-2 py-1 rounded" data-id="element-370">
            {String(time.hours).padStart(2, '0')}
          </span>
          <span data-id="element-371">:</span>
          <span className="bg-black/30 px-2 py-1 rounded" data-id="element-372">
            {String(time.minutes).padStart(2, '0')}
          </span>
          <span data-id="element-373">:</span>
          <span className="bg-black/30 px-2 py-1 rounded" data-id="element-374">
            {String(time.seconds).padStart(2, '0')}
          </span>
        </div>
      </div>
    </div>;
}